module.exports = __webpack_public_path__ + "static/media/0043.a454869f.svg";